// ----------------------------------------------------------------------
// <copyright file="Izenda.DrillPopup.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import connect from 'share/enhancers/Izenda.Connect';
import Popup from 'share/components/controls/CommonPopup/Izenda.Popup';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import ScrollBox from 'share/components/controls/Izenda.ScrollBox';

const Anchor = ({ label, ...othersProps }) => (
  <a {...othersProps} className='u_textLink'>
    {label}
  </a>
);
const Label = ({ label, ...othersProps }) => {
  othersProps.onClick = () => { };
  return (
    <span {...othersProps}>
      {label}
    </span>
  );
};
const BODY_HEIGHT = 150;

const DrillPopup = props => {
  const { localization, dataSource } = props;

  return (
    <Popup visible onClosed={handleClosed} type='none' sizeClass='modal-sm'>
      <Popup.Header title={localization.getText('REPORTDESIGNER_DRILL_OTHERS_POPUP_LABEL')} />
      <Popup.Body>
        <div style={{ height: BODY_HEIGHT }}>
          <ScrollBox>{renderContainer()}</ScrollBox>
        </div>
      </Popup.Body>
    </Popup>
  );

  function handleClosed() {
    props.onAccept();
  }

  function renderContainer() {
    if (!dataSource) return localization.getText('NO_VALUE_FOUND');
    const Item = getItemComponent();
    return (
      <GridLayout>
        {dataSource.map(item => (
          <div key={item.label} className='u_paddingBottom overflow-text'>
            <Item label={item.label} onClick={handleClick.bind(null, item)} title={item.label} />
          </div>
        ))}
      </GridLayout>
    );
  }

  function getItemComponent() {
    return props.isClickable ? Anchor : Label;
  }

  function handleClick(item) {
    props.onAccept(item);
  }
};

DrillPopup.propsType = {
  dataSource: PropTypes.object,
  localization: PropTypes.object,
  isClickable: PropTypes.bool
};

export default connect()(DrillPopup);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.DrillPopup.js